import { api, API_MONO, monolithCache } from '../api/api'

export const getCateringStoresForLocationApi = (locationId, isHome) => {
  return api.get(`${API_MONO}/location/${locationId}/catering-schedule?home=${isHome}`, null, {
    cache: monolithCache,
  })
}
